"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.router = exports.initStorage = exports.saveCurrentValueInStorage = exports.getQuestionValue = exports.checkAnswersAndSendBulk = exports.checkAnswerAndSend = exports.checkIsNewValue = exports.storage = void 0;
const effects_1 = require("redux-saga/effects");
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const question_1 = require("src/utils/question");
const actions_1 = require("../actions");
const selectors_1 = require("./selectors");
const consts_1 = require("./consts");
exports.storage = {};
function* checkIsNewValue({ questionIndex, value }) {
    if (!(0, isEqual_1.default)(value, exports.storage[questionIndex])) {
        yield (0, effects_1.call)(saveCurrentValueInStorage, questionIndex);
        return true;
    }
    return false;
}
exports.checkIsNewValue = checkIsNewValue;
function* checkAnswerAndSend({ questionIndex }) {
    const value = yield (0, effects_1.call)(getQuestionValue, questionIndex);
    const isNewValue = yield (0, effects_1.call)(checkIsNewValue, { questionIndex, value });
    if (isNewValue) {
        const slug = yield (0, effects_1.select)(selectors_1.getSlug);
        yield (0, effects_1.put)((0, actions_1.sendAnswerRequest)(slug, value));
    }
}
exports.checkAnswerAndSend = checkAnswerAndSend;
function* checkAnswersAndSendBulk({ nodes }) {
    nodes = nodes.filter(({ type }) => type === 'question');
    const answers = [];
    for (const { id } of nodes) {
        const value = yield (0, effects_1.call)(getQuestionValue, id);
        const isNewValue = yield (0, effects_1.call)(checkIsNewValue, { questionIndex: id, value });
        if (isNewValue) {
            answers.push(value);
        }
    }
    if (answers.length) {
        const slug = yield (0, effects_1.select)(selectors_1.getSlug);
        yield (0, effects_1.put)((0, actions_1.sendAnswerBulkRequest)(slug, { answers }));
    }
}
exports.checkAnswersAndSendBulk = checkAnswersAndSendBulk;
function* getQuestionValue(questionIndex) {
    const questions = yield (0, effects_1.select)(selectors_1.getQuestions);
    const charLimits = yield (0, effects_1.select)(selectors_1.getCharLimits);
    const model = (0, question_1.createQuestionModel)(questions, questionIndex, { charLimits });
    const valueAsObj = model.getValueAsObj();
    if ('text' in valueAsObj && valueAsObj.text)
        valueAsObj.text = valueAsObj.text.trim();
    return Object.assign({ questionId: model.state.id }, valueAsObj);
}
exports.getQuestionValue = getQuestionValue;
function* saveCurrentValueInStorage(questionIndex) {
    const value = yield (0, effects_1.call)(getQuestionValue, questionIndex);
    exports.storage[questionIndex] = (0, cloneDeep_1.default)(value);
}
exports.saveCurrentValueInStorage = saveCurrentValueInStorage;
function* initStorage() {
    const questions = yield (0, effects_1.select)(selectors_1.getQuestions);
    const indexes = Object.keys(questions).map(i => questions[i].id);
    for (const questionIndex of indexes) {
        yield (0, effects_1.call)(saveCurrentValueInStorage, questionIndex);
    }
}
exports.initStorage = initStorage;
function* router() {
    // @ts-expect-error TS(2769): No overload matches this call.
    yield (0, effects_1.takeEvery)('NODE_VISIBILITY_CHANGED', checkAnswersAndSendBulk);
    // @ts-expect-error TS(2769): No overload matches this call.
    yield (0, effects_1.takeEvery)(consts_1.QUESTION_CHANGE_ACTIONS, checkAnswerAndSend);
    yield (0, effects_1.takeEvery)(consts_1.SURVEY_SUCCESSFUL_LOAD_ACTIONS, initStorage);
}
exports.router = router;
